import { INVENTORY, PLACEMENT_TYPE_HERO } from "../helpers/consts";
import { TILES } from "../helpers/tiles";
import Sprite from "../components/object-graphics/Sprite";
import { PickupPlacement } from "./PickupPlacement";

export class ClownDefensePickupPlacement extends PickupPlacement {
  addsItemToInventoryOnCollide(body) {
    if (
      body.type === PLACEMENT_TYPE_HERO &&
      !this.level.inventory.has(INVENTORY.CLOWN_DEFENSE)
    ) {
      return INVENTORY.CLOWN_DEFENSE;
    }
    return null;
  }

  canBeStolen() {
    return false;
  }

  renderComponent() {
    return <Sprite frameCoord={TILES.CLOWN_DEFENSE_PICKUP} />;
  }
}
